import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Input, Button } from "antd";

import './style.css';
const InputProps = {...Input.defaultProps,...Input.propTypes,onChange:()=>{}}

/**
 * Input输入框
 */
class RmtInput extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: ""
        };
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        const suffixDom = document.querySelector(`div[data-name ='${this.props.name}'] .rmt-input-suffix-layout`);
        if (suffixDom) {
            observer.observe(suffixDom);
        }
        this.updateValue();
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(RmtInput.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }

            return {...state,fieldProps:{...newProps}}
        }
        return state
    }

    //获取抖音链接方式
    getLink() {
        window.openPage({
            url: window.framereactPath + "index.html#/newMedia/positionManage/douYinLink",
            params: {},
        })
    }

    render() {
        const {style={}} = this.props.fieldProps;
        const { fieldProps, suffixWidth } = this.state;
        return (
            <>
                <div className="rmt-input dy-link">
                    <div className="rmt-input-content-layout" style={style}>
                        <Input {...fieldProps} id={this.props.name} value={this.state.value} onChange={(e)=>{
                            this.setState({value:e.target.value})
                            fieldProps.onChange(e.target.value);
                        }} />
                    </div>
                    <div className="rmt-input-suffix-layout">
                        <span style={{cursor: "pointer"}} onClick={() => this.getLink()}>链接如何获取？</span>
                    </div>
                    <style>
                        {
                            `div[data-name = '${this.props.name}'] .ant-form-item-children .dy-link ~ .ant-form-item-children-icon {
                            left: calc(100% - ${suffixWidth>0? suffixWidth : 35}px);
                        }`
                        }
                    </style>
                </div>
            </>
        )
    }

    // 更新组件内部value
    updateValue(refreshData) {
        if (refreshData) {
            const updateStack = {};
            for (const item of refreshData) {
                if (Object.keys(this.props.fieldProps).includes(item)) {
                    updateStack[item] = this.props.fieldProps[item];
                }
            }
            this.setState({...updateStack})
        }else {
            this.setState({
                value: this.props.fieldProps.value,
            })
        }
    }
}
export default RmtInput;

RmtInput.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

RmtInput.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: ()=>{}
}